import React from "react";
import { Button, ButtonProps } from "@emisgroup/ui-button";
import "./Style.scss";

interface CustomButtonProps {
  /**
   * Children to render
   */
  children?: React.ReactNode;
  /**
   * Button text
   */
  btnText?: string;
}

type BtnProps = ButtonProps & CustomButtonProps;

/**
 * Responsible for rendering the button
 * @returns button element
 */
export const UIButton: React.FC<BtnProps> = (props: BtnProps) => {

  const { btnText, children } = props;
  const { className, ...remainingProps } = props;

  return (
    <Button
      className={`${className} ui-button`}
      {...remainingProps}
    >
      {btnText}
      {children}
    </Button>
  );
};
